import { GET_DEPARTMENT_FORM_SUCCESS } from "../../common/actionTypes";
import { getEnv } from "../../enviroment";
import { fetch_retry_get, fetch_retry_post } from "./ApiManager";
const { base } = getEnv();

const getDepartmentForm = (payload) => async (dispatch) => {
  try {
    let response = await fetch_retry_get(`${base}/form/${payload}`);
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      dispatch({
        type: GET_DEPARTMENT_FORM_SUCCESS,
        payload: resp.data,
      });
      return { success: true, data: resp };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getDashboardRequests =
  (payload, selectedRequests) => async (dispatch) => {
    try {
      let response = await fetch_retry_post(
        `${base}/change-request/${selectedRequests}`,
        payload
      );
      let resp = await response;
      if (resp && (resp.status === 200 || resp.status === 201)) {
        return { success: true, data: resp.data };
      } else {
        return { success: false, message: resp?.data?.message };
      }
    } catch (error) {
      console.error("error", error);
      return { success: false, message: error.data };
    }
  };

const getRequestsOverview = () => async (dispatch) => {
  try {
    let response = await fetch_retry_get(`${base}/change-request/summary`);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getFlowSubTickets = (parentId) => async (dispatch) => {
  try {
    let response = await fetch_retry_get(
      `${base}/sub-request/get/${parentId}`,
      parentId
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const getStatusByRequestId = (id) => async (dispatch) => {
  try {
    let response = await fetch_retry_get(
      `${base}/change-request/get/nextPossibleStatus/${id}`
    );
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response?.data?.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

const changeStatusByRequestId = (id, payload) => async (dispatch) => {
  try {
    let response = await fetch_retry_post(
      `${base}/change-request/update/status/${id}`,
      payload
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

export const dashboardActions = {
  getDepartmentForm,
  getRequestsOverview,
  getDashboardRequests,
  getFlowSubTickets,
  getStatusByRequestId,
  changeStatusByRequestId,
};
